module.exports = flarum.core.compat['components/AdminLinkButton'];